import Person from '@mui/icons-material/Person';
import { Box, IconButton, Menu, MenuItem, MenuList } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import { useAuth } from '~/providers/AuthProvider';

export const AccountMenu: FC = () => {
  const { logout } = useAuth();
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const isOpen = !!anchorElement;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorElement(event.currentTarget);
  const handleClose = () => {
    setAnchorElement(null);
  };
  const handleLogout = () => {
    logout({ isExpired: false });
    handleClose();
  };

  return (
    <Box>
      <IconButton
        data-testid="account-menu-button"
        id="header_account_icon_button"
        onClick={handleClick}
        aria-controls={'account-menu'}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        sx={{ width: { xs: 48, md: 40 } }}
      >
        <Person color="primary" sx={{ width: '100%', height: '100%' }} />
      </IconButton>

      <Menu
        data-testid="account-menu"
        anchorEl={anchorElement}
        id="account-menu"
        open={isOpen}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 1px #00000033)',
              mt: 1.5,
              '& .MuiMenu-list': {
                py: 0
              }
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuList sx={{ py: 0, minWidth: 108 }}>
          <MenuItem
            onClick={handleLogout}
            sx={{ py: 1, px: 2 }}
            id="header_account_logout_button"
            data-testid="account-menu-close"
          >
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};
